<template>
  <div class="home">
    <header-top></header-top>
    <search-c></search-c>
    <router-view v-if="routerType"></router-view>
    <HomePage v-else></HomePage>
    <footer-view></footer-view>
  </div>
</template>

<script>
import Header from '@/base/header/header'
import Search from '@/base/search/search'
import Footer from '@/base/footer/footer'
import HomePage from '@/components/Home/homePage'
export default {
  name: 'home',
  components: {
    'header-top': Header,
    'search-c': Search,
    'footer-view': Footer,
    'HomePage': HomePage
  },
  data () {
    return {
      routerType: true
    }
  },
  created () {
    if (this.$route.name === 'Home') {
      this.routerType = false
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'Home') {
        this.routerType = false
      } else {
        this.routerType = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .home{
    width: 1200px;
    margin: auto;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue


// WEBPACK FOOTER //
// src/components/home.vue